import { render, staticRenderFns } from "./ProjectHistoryModal.vue?vue&type=template&id=71d71cd5&scoped=true"
import script from "./ProjectHistoryModal.vue?vue&type=script&lang=ts"
export * from "./ProjectHistoryModal.vue?vue&type=script&lang=ts"
import style0 from "./ProjectHistoryModal.vue?vue&type=style&index=0&id=71d71cd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d71cd5",
  null
  
)

export default component.exports